/* Shalom Bonic: bloques de conversion en la ficha (beneficios, resenas verificadas, complemento, optometra, comparativa) */
(function(){
  if(window.__sbBloques) return; window.__sbBloques=1;
  if(location.pathname.indexOf('/products/')!==0) return;
  try{ if(new URLSearchParams(location.search).get('drawer')==='1') return; }catch(e){}
  var P=window.__sbPV||{};
  var ES_LENTE=!!P.k;
  var BUMP={id:57133019922757,t:'Solución Multiusos 120ml',d:'Limpia, desinfecta e hidrata tus lentes',p:29600,img:'https://cdn.shopify.com/s/files/1/1012/4256/9029/files/F312A4EE-9763-42CE-9B60-573EB6E54B67.jpg?v=1774240159&width=200',u:'/products/solucion-multiusos-shalom-bonic-120ml-formula-especial-para-lentes-de-color'};
  var REV=window.__sbREV||[];
  var V='#8C1D40';
  var css=
  '#sb-ben{list-style:none;margin:4px 0 12px;padding:0;width:100%;flex-basis:100%}'+
  '#sb-ben li{display:flex;align-items:center;gap:10px;margin:0 0 8px;font-size:14px;line-height:1.35;color:#1E1D1B}'+
  '#sb-ben svg{flex:none;width:20px;height:20px;color:'+V+'}'+
  '#sb-rv{width:100%;max-width:100%;min-width:0;overflow:hidden;contain:inline-size;margin:10px 0 4px;box-sizing:border-box}'+
  '#sb-rv .h{display:flex;align-items:center;justify-content:space-between;padding:0 16px;margin:0 0 8px;font-size:12px;letter-spacing:.08em;text-transform:uppercase;color:#6B5A61;font-weight:700}'+
  '#sb-rv .h small{font-weight:500;letter-spacing:0;text-transform:none}'+
  '#sb-rv .tr{display:flex;gap:10px;overflow-x:auto;scroll-snap-type:x mandatory;padding:2px 16px 10px;scrollbar-width:none;-webkit-overflow-scrolling:touch}'+
  '#sb-rv .tr::-webkit-scrollbar{display:none}'+
  '#sb-rv .c{flex:0 0 82%;max-width:320px;scroll-snap-align:start;box-sizing:border-box;border:1px solid #E9D9DF;border-radius:14px;background:#fff;padding:12px 14px;display:flex;flex-direction:column;gap:8px}'+
  '#sb-rv .s{color:'+V+';font-size:13px;letter-spacing:2px}'+
  '#sb-rv .t{font-size:13.5px;line-height:1.4;color:#1E1D1B;margin:0;display:-webkit-box;-webkit-line-clamp:4;-webkit-box-orient:vertical;overflow:hidden}'+
  '#sb-rv .a{display:flex;align-items:center;gap:8px;margin-top:auto;font-size:12px;color:#6B5A61}'+
  '#sb-rv .a img{width:34px;height:34px;border-radius:50%;object-fit:cover;flex:none}'+
  '#sb-rv .a b{color:#1E1D1B;font-weight:700}'+
  '#sb-rv .ok{display:inline-block;font-size:10.5px;color:#2E7D4F;font-weight:600}'+
  '#sb-bump{width:100%;flex-basis:100%;box-sizing:border-box;margin:12px 0 4px;display:flex;align-items:center;gap:12px;border:1px solid #E9D9DF;border-radius:14px;background:#FBF6F8;padding:10px 12px}'+
  '#sb-bump img{width:56px;height:56px;border-radius:10px;object-fit:cover;flex:none;background:#fff}'+
  '#sb-bump .i{flex:1;min-width:0}'+
  '#sb-bump .k{font-size:11px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;color:'+V+'}'+
  '#sb-bump .n{font-size:14px;font-weight:700;color:#1E1D1B;line-height:1.2}'+
  '#sb-bump .d{font-size:12px;color:#6B5A61}'+
  '#sb-bump .p{font-size:13px;font-weight:700;color:#1E1D1B}'+
  '#sb-bump button{flex:none;width:48px;height:28px;border-radius:999px;border:0;background:#D9CDD2;position:relative;cursor:pointer;padding:0;transition:background .2s}'+
  '#sb-bump button::after{content:"";position:absolute;top:3px;left:3px;width:22px;height:22px;border-radius:50%;background:#fff;box-shadow:0 1px 3px rgba(0,0,0,.2);transition:left .2s}'+
  '#sb-bump button[aria-checked="true"]{background:'+V+'}'+
  '#sb-bump button[aria-checked="true"]::after{left:23px}'+
  '#sb-bump button[disabled]{opacity:.6}'+
  '.sb-blk{max-width:1100px;margin:0 auto;padding:36px 16px;box-sizing:border-box;text-align:center}'+
  '.sb-blk h2{font-size:26px;line-height:1.15;margin:0 0 6px;color:#1E1D1B;font-weight:700}'+
  '.sb-blk h2 em{font-style:normal;color:'+V+'}'+
  '.sb-blk .sub{font-size:15px;color:#6B5A61;margin:0 auto 18px;max-width:560px;line-height:1.4}'+
  '#sb-opt,#sb-vs{width:100%;flex:0 0 auto;align-self:stretch}#sb-opt{background:#FBF4F6}'+
  '#sb-opt video{display:block;width:100%;max-width:360px;margin:0 auto;border-radius:18px;background:#000;aspect-ratio:9/16;object-fit:cover}'+
  '#sb-opt .nm{margin:12px 0 0;font-size:14px;color:#1E1D1B}'+
  '#sb-opt .nm b{display:block;font-size:15px}'+
  '#sb-vs table{width:100%;max-width:640px;margin:0 auto;border-collapse:separate !important;border-spacing:0;table-layout:fixed;border:0 !important;letter-spacing:0 !important}'+
  '#sb-vs th,#sb-vs td{border:0 !important;box-shadow:none !important;background:transparent;word-break:normal;overflow-wrap:break-word;hyphens:auto}'+
  '#sb-vs th{overflow-wrap:normal;hyphens:manual;letter-spacing:0 !important;font-size:11px !important;font-weight:600;color:#6B5A61;padding:0 3px 10px !important;vertical-align:bottom;line-height:1.25 !important}'+
  '#sb-vs th.sb{color:'+V+';font-weight:800;font-size:12px !important;background:#FBF1F4;border-radius:12px 12px 0 0 !important;padding-top:12px !important}'+
  '#sb-vs td{padding:11px 3px !important;border-top:1px solid #EFE6E9 !important;text-align:center;vertical-align:middle;color:#6B5A61;font-size:11px !important;line-height:1.25 !important}'+
  '#sb-vs th:first-child,#sb-vs td:first-child{width:36%}'+
  '#sb-vs td:first-child{text-align:left;color:#1E1D1B;font-size:12.5px !important;font-weight:500;padding-left:6px !important}'+
  '#sb-vs td.sb{background:#FBF1F4 !important}'+
  '#sb-vs tr:last-child td.sb{border-radius:0 0 12px 12px !important}'+
  '#sb-vs .y,#sb-vs .x{display:inline-flex;width:22px;height:22px;border-radius:50%;align-items:center;justify-content:center;font-size:12px;font-weight:700;color:#fff}'+
  '#sb-vs .y{background:'+V+'}#sb-vs .x{background:#C9BCC1}'+
  '#sb-vs .nt{font-size:11.5px;color:#9A8B91;margin:12px 0 0}#sb-vs .nt a{color:#9A8B91;text-decoration:underline}';
  var st=document.createElement('style'); st.textContent=css; document.head.appendChild(st);

  function esc(s){ return String(s).replace(/[&<>"]/g,function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
  function visible(el){ if(!el) return false; var r=el.getBoundingClientRect(); return r.width>0&&r.height>0; }
  var SEL='form[action*="/cart/add"] .gp-button-atc, form[action*="/cart/add"] button[name="add"]';
  function mainBtn(){
    var l=document.querySelectorAll(SEL);
    for(var i=0;i<l.length;i++){ if(!l[i].closest('#sb-sticky')&&l[i].closest('gp-product')===principal()&&visible(l[i])) return l[i]; }
    return null;
  }
  function principal(){
    var g=document.querySelector('gp-product gp-product-images');
    return g?g.closest('gp-product'):null;
  }
  var ICO={
    ojo:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12z"/><circle cx="12" cy="12" r="3"/></svg>',
    gota:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3s6 6.5 6 11a6 6 0 0 1-12 0c0-4.5 6-11 6-11z"/></svg>',
    escudo:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3l8 3v6c0 4.5-3.4 8.2-8 9-4.6-.8-8-4.5-8-9V6z"/><path d="M8.5 12l2.5 2.5 4.5-5"/></svg>',
    doc:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="7" r="4"/><path d="M4 21c1.5-4 4.5-6 8-6s6.5 2 8 6"/></svg>'
  };
  /* 1) Beneficios antes de comprar */
  function beneficios(){
    if(!ES_LENTE) return true;
    if(document.getElementById('sb-ben')) return true;
    var b=mainBtn(); if(!b) return false;
    var anc=document.getElementById('sb-cuotas')||b;
    var u=document.createElement('ul'); u.id='sb-ben';
    [['ojo','Color natural que se funde con tu mirada'],['gota','Cómodos todo el día: hidratados y oxigenados'],['escudo','Aprobados por INVIMA, con normas ISO 13485 y CE'],['doc','Respaldo de optómetra y garantía de fabricación']].forEach(function(x){
      var li=document.createElement('li'); li.innerHTML=ICO[x[0]]+'<span>'+x[1]+'</span>'; u.appendChild(li);
    });
    anc.insertAdjacentElement('beforebegin',u);
    return true;
  }
  /* 2) Barra de reseñas verificadas debajo de las fotos */
  function resenas(){
    if(document.getElementById('sb-rv')) return true;
    if(!REV.length) return true;
    var g=document.querySelector('gp-product gp-product-images'); if(!g) return false;
    var mias=REV.filter(function(r){ return location.pathname==='/products/'+r.h; });
    var l=mias.concat(REV.filter(function(r){ return mias.indexOf(r)<0; }));
    var d=document.createElement('div'); d.id='sb-rv';
    var h='<div class="h">Lo que dicen nuestras clientas <small>compras verificadas</small></div><div class="tr">';
    l.forEach(function(r){
      h+='<div class="c"><div class="s">★★★★★</div><p class="t">'+esc(r.t)+'</p><div class="a">'+(r.f?'<img src="'+esc(r.f)+'" alt="" loading="lazy">':'')+'<div><b>'+esc(r.n)+'</b> · '+esc(r.p)+'<br><span class="ok">✓ Compra verificada</span></div></div></div>';
    });
    d.innerHTML=h+'</div>';
    g.insertAdjacentElement('afterend',d);
    return true;
  }
  /* 3) Complemento con interruptor (se agrega/quita del carrito al instante) */
  function burbuja(){
    fetch('/?sections=cart-icon-bubble').then(function(r){ return r.json(); }).then(function(s){
      var e=document.getElementById('cart-icon-bubble'); if(!e||!s['cart-icon-bubble']) return;
      var t=document.createElement('div'); t.innerHTML=s['cart-icon-bubble'];
      var n=t.querySelector('#shopify-section-cart-icon-bubble')||t; e.innerHTML=n.innerHTML;
    }).catch(function(){});
  }
  function enCarrito(cb){ fetch('/cart.js').then(function(r){ return r.json(); }).then(function(c){ var it=null; (c.items||[]).forEach(function(i){ if(i.variant_id===BUMP.id) it=i; }); cb(it); }).catch(function(){ cb(null); }); }
  function complemento(){
    if(!ES_LENTE) return true;
    if(document.getElementById('sb-bump')) return true;
    var b=mainBtn(); if(!b) return false;
    var f=b.closest('form'); if(!f) return false;
    var d=document.createElement('div'); d.id='sb-bump';
    d.innerHTML='<img src="'+BUMP.img+'" alt="" loading="lazy"><div class="i"><div class="k">Complementa tus lentes</div><div class="n">'+BUMP.t+'</div><div class="d">'+BUMP.d+'</div><div class="p">+ $'+BUMP.p.toLocaleString('es-CO')+'</div></div><button type="button" role="switch" aria-checked="false" aria-label="Agregar '+BUMP.t+'"></button>';
    f.insertAdjacentElement('afterend',d);
    var sw=d.querySelector('button');
    enCarrito(function(it){ if(it) sw.setAttribute('aria-checked','true'); });
    sw.addEventListener('click',function(ev){
      ev.preventDefault(); ev.stopPropagation();
      var on=sw.getAttribute('aria-checked')!=='true';
      sw.disabled=true; sw.setAttribute('aria-checked',on?'true':'false');
      var hecho=function(){ sw.disabled=false; burbuja(); };
      if(on){
        fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:BUMP.id,quantity:1}]})}).then(function(r){ if(!r.ok) sw.setAttribute('aria-checked','false'); hecho(); }).catch(function(){ sw.setAttribute('aria-checked','false'); hecho(); });
      }else{
        enCarrito(function(it){
          if(!it){ hecho(); return; }
          fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:it.key,quantity:Math.max(0,it.quantity-1)})}).then(hecho).catch(hecho);
        });
      }
    });
    return true;
  }
  /* 4) Optometra + 5) Comparativa, justo despues del bloque de compra */
  function secciones(){
    if(!ES_LENTE) return true;
    if(document.getElementById('sb-vs')) return true;
    var gp=principal(); if(!gp) return false;
    var ancla=gp, VID=String(window.__sbVID||''), POSTER=String(window.__sbPOSTER||'');
    if(VID.indexOf('http')===0){
      var o=document.createElement('section'); o.id='sb-opt';
      o.innerHTML='<div class="sb-blk"><h2>Respaldados por un <em>optómetra</em></h2><p class="sub">Carlos Sánchez, optómetra y director técnico de Shalom Bonic, te cuenta cómo cuidamos cada lente.</p><video src="'+VID+'"'+(POSTER?' poster="'+POSTER+'"':'')+' controls playsinline preload="metadata"></video><p class="nm"><b>Carlos Sánchez</b>Optómetra y director técnico</p></div>';
      ancla.insertAdjacentElement('afterend',o); ancla=o;
    }
    var Y='<span class="y">✓</span>', X='<span class="x">✕</span>';
    var filas=[
      ['Colores naturales',Y,'No siempre','Varía'],
      ['Gran variedad de tonos',Y,'Varía','Pocos'],
      ['Garantía de satisfacción*',Y,X,'Varía'],
      ['Registro INVIMA',Y,'No siempre',Y],
      ['Con tu fórmula de miopía o astigmatismo',Y,'Pocas',Y],
      ['Respaldo de optómetra',Y,X,Y],
      ['Envío a tu casa en 1 a 4 días hábiles',Y,'Varía',X],
      ['Pago a cuotas con Addi o Sistecrédito',Y,'Varía','Varía']
    ];
    var v=document.createElement('section'); v.id='sb-vs';
    var h='<div class="sb-blk"><h2>¿Por qué <em>Shalom Bonic</em>?</h2><p class="sub">Compara antes de elegir lo que te pones en los ojos.</p><table><thead><tr><th></th><th class="sb">Shalom Bonic</th><th>Lentes genéricos de internet</th><th>Óptica tradicional</th></tr></thead><tbody>';
    filas.forEach(function(f){ h+='<tr><td>'+f[0]+'</td><td class="sb">'+f[1]+'</td><td>'+f[2]+'</td><td>'+f[3]+'</td></tr>'; });
    v.innerHTML=h+'</tbody></table><p class="nt">*Aplican <a href="/pages/garantia-de-satisfaccion">términos y condiciones</a>.</p></div>';
    ancla.insertAdjacentElement('afterend',v);
    return true;
  }
  function seguro(fn){ try{ return fn(); }catch(e){ return false; } }
  var n=0, a=false, r=false, c=false, s=false;
  var iv=setInterval(function(){
    n++;
    if(!r) r=seguro(resenas);
    if(!a) a=seguro(beneficios);
    if(!c) c=seguro(complemento);
    if(!s) s=seguro(secciones);
    if((a&&r&&c&&s)||n>40) clearInterval(iv);
  },350);
})();